import React from 'react';

const FuturePayment = (props) => {
  const rows = [
    {title: 'תאריך רכישה', description: props.payment.currentPayment.actionDate.replaceAll('/', '.')},
    {
      title: 'מספר התשלומים שנותרו',
      description:
        props.payment.currentPayment.remainingPayments + ' ' + 'מתוך' + ' ' + props.payment.currentPayment.totalInstallmentsNumber,
    },
    props.payment.currentPayment.firstPayment && {title: 'תשלום ראשון', description: props.payment.currentPayment.firstPayment},
    {title: 'גובה כל תשלום', description: props.payment.currentPayment.amountWithVAT},
  ];

  return (
    <div className='future-payment-container'>
      <span className='payment-product-title'>{props.payment.currentPayment.productTitle}</span>
      <div className='future-payment'>
        {rows.map((row) => {
          return (
            <div className='payment-description-row'>
              <span className='title'>{row?.title}</span>
              <span className='description'>{row?.description}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default FuturePayment;
